export default function Err404(){
    return(
              <h3>404</h3>
    )
}